import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import DehumidifyIcon from '@/components/zoneDevices/widgets/DehumidifierIcon.vue';
import FanIcon from '@/components/zoneDevices/widgets/FanIcon.vue';
import Co2Icon from '@/components/zoneDevices/widgets/Co2Icon.vue'
import SoilTempIcon from "@/components/zoneDevices/widgets/SoilTempIcon.vue";
import SoilECIcon from "@/components/zoneDevices/widgets/SoilECIcon.vue";
import EpsilonIcon from "@/components/zoneDevices/widgets/EpsilonIcon.vue";
import { i18n } from "../vue-i18n";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'mdi',
    values : {
      dehumidifier : {
        component: DehumidifyIcon
      },
      fan : {
        component: FanIcon
      },
      co2 : {
        component: Co2Icon
      },
      soilTemp: {
        component: SoilTempIcon
      },
      soilEC: {
        component: SoilECIcon
      },
      epsilon: {
        component: EpsilonIcon
      }
    }
  },
});
